import useUserPermission from "~/hooks/useUserPermission";

const useCanEditAdminApp = () => {
  return useUserPermission("write:admin-app");
};

export default useCanEditAdminApp;
